const COMMON = {
    phone_number: "01 86 76 08 88",
    freshchatToken: "dd236894-2724-479c-a251-84c3edef28eb",
    orders: {
        status_label: {
            oncoming: { title: "Commande enregistrée", subtitle: "Un tanker sera bientôt attribué à votre commande" },
            waiting: { title: "Commande en attente", subtitle: "Votre commande est en attente de confirmation" },
            ready: { title: "Commande attribuée", subtitle: "Un tanker à été attribué à votre commande" },
            processing: { title: "Commande en cours", subtitle: "Votre tanker livre votre commande" },
            delivered: { title: "Commande livrée", subtitle: "" }
        }
    },
    gas: {
        gazole: {
            color: "rgba(241, 196, 15, 1.0)"
        },
        sp95: {
            color: "rgba(46, 204, 113, 1.0)"
        }
    },
    enterprise_activities: [
        "Agroalimentaire",
        "Banque / Assurance",
        "Bois / Papier / Carton / Imprimerie",
        "BTP / Matériaux de construction",
        "Chimie / Parachimie",
        "Commerce / Négoce / Distribution",
        "Édition / Communication / Multimédia",
        "Électronique / Électricité",
        "Études et conseils",
        "Industrie pharmaceutique",
        "Informatique / Télécoms",
        "Machines et équipements / Automobile",
        "Métallurgie / Travail du métal",
        "Plastique / Caoutchouc",
        "Services aux entreprises",
        "Textile / Habillement / Chaussure",
        "Transports / Logistique"
    ],
    months: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
    weekdays_long: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    weekdays_short: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    invoice_payment: [
        "Non",
        "Oui",
        "En attente",
        "Defaut de paiement",
        "Programmé",
        "Erreur lors du paiement"
    ],
    business_customer_notifications_types: [
        { title: "Tout", value: 0 },
        { title: "Opérations", value: 1 },
        { title: "Factures", value: 2 },
        { title: "Aucun", value: 10 }
    ],
    businessContactTypes: [
        { value: "SALES", label: 'Commercial' },
        { value: "OPS", label: 'Opérationnel' },
        { value: "ALL", label: 'Les deux' }
    ],
    energies: [
        { value: 0, label: "Carburants", subTypes: [] },
        { value: 1, label: "Electrique", subTypes: [
            { value: 0, label: "AC_DC" },
            { value: 1, label: "AC" },
            { value: 2, label: "DC" }
        ] }
    ],
    invoiceV2PaymentStatus: [
        { value: "not-paid,lost", label: "Non payée" },
        { value: "paid", label: "Payée" },
        { value: "cancelled", label: "Annulée" }
    ]
};

export { COMMON };



// WEBPACK FOOTER //
// ./src/Utils/configs/common.js